import { useEffect, useState } from 'react';
import { useGamificationMainStore } from '../../modules/Gamification/stores/useGamificationMainStore';
import { useUserStore } from '../../modules/Auth/stores/authStore';

export const useShouldShowPopUpScore = () => {
  const { user } = useUserStore();
  const { status } = useGamificationMainStore();

  const [shouldShowPopUpScore, setShouldShowPopUpScore] =
    useState<boolean>(false);
  const [shouldShowBadgeScore, setShouldShowBadgeScore] =
    useState<boolean>(false);

  useEffect(() => {
    if (status === 'playing' && user?.exerciseShowScoreNotification) {
      setShouldShowPopUpScore(true);
    }

    if (status === "playing") setShouldShowBadgeScore(true);
  }, [status, user?.exerciseShowScoreNotification]);

  return {
    shouldShowPopUpScore,
    shouldShowBadgeScore
  };
};
